import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackShopping } from "@/lib/shopAnalytics";
export default function ShoppingAnalytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    trackShopping("page_view");
    if (pathname === "/shop") trackShopping("shop_visit");
    let active = 0;
    const timer = window.setInterval(() => {
      if (document.visibilityState !== "visible") return;
      active += 5;
      if (active === 10 || (active > 10 && (active - 10) % 30 === 0)) trackShopping("engagement", { active_seconds: active === 10 ? 10 : 30 });
    }, 5000);
    return () => window.clearInterval(timer);
  }, [pathname, search]);
  return null;
}